// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Service, ControllerService } from '@tencent/workbench';
import { LinePanelType } from '@tencent/chart-drawer-components/lib/interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { getPcInjectedService } from '@src/framework/workbench/util/injector-service';
import ChartShapeProperty from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import model from '@tencent/memoire-structured-storage/typings/model';

@Service()
export class ChartService {
    private linePanelType;

    public constructor(private controllerService: ControllerService) {
        this.buildController();
        this.setLinePanelType(LinePanelType.LINE);
    }

    public setLinePanelType(panelType) {
        this.linePanelType = panelType;
    }

    public showMarkerPanel() {
        return this.linePanelType === LinePanelType.MARKER;
    }

    public getSelectedElementModel(model) {
        if (!model || model.type !== UIModelType.CHART || !model.selectedElement) return;
        const showMarker = (getPcInjectedService(ChartService) as ChartService).showMarkerPanel();
        const selectedElement = model.getSelectedElementProperty(showMarker) as ChartShapeProperty;
        return selectedElement;
    }

    private buildController() {
        import(/* webpackChunkName: "chart-drawer-components" */ '@tencent/chart-drawer-components')
            .then((module) => {
                const {
                    ChartElementController,
                    ChartTypeController,
                    ChartLegendController,
                    ChartAxisSettingsController,
                    ChartAxisTitleController,
                    ChartDataLabelController,
                    ChartLineMarkerSeletorController,
                    MarkerOptionsController,
                    ChartThemeColorController,
                    SeriesOptionsController,
                } = module;
                this.controllerService.buildController(ChartElementController);
                this.controllerService.buildController(ChartTypeController);
                this.controllerService.buildController(ChartLegendController);
                this.controllerService.buildController(ChartAxisSettingsController);
                this.controllerService.buildController(ChartAxisTitleController);
                this.controllerService.buildController(ChartDataLabelController);
                this.controllerService.buildController(ChartLineMarkerSeletorController);
                this.controllerService.buildController(MarkerOptionsController);
                this.controllerService.buildController(ChartThemeColorController);
                this.controllerService.buildController(SeriesOptionsController);
            })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });
    }
}
